export default __webpack_public_path__ + "static/media/android-robot-head.92760408.png";